import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import WhiteCard from "src/shared/components/WhiteCard";

const GLP1NextSteps = () => {
  const { t } = useTranslation();
  const component = "next-steps";

  return (
    <Stack gap={2}>
      <WhiteCard gap={1}>
        <Typography fontWeight={700} variant="body2">
          {t(`${component}.card-1.header`, "What Happens Next")}
        </Typography>
        <Typography>
          {t(
            `${component}.card-1.text`,
            "A licensed provider will review your consultation. If approved, your prescription is sent to the pharmacy for preparation. Once ready, your medication ships directly to your address, and you’ll receive tracking information."
          )}
        </Typography>
      </WhiteCard>
      <WhiteCard gap={1}>
        <Typography fontWeight={700} variant="body2">
          {t(`${component}.card-2.header`, "Pharmacy Preparation")}
        </Typography>
        <Typography>
          {t(
            `${component}.card-2.text`,
            "Your prescription is sent to the pharmacy where your medication is carefully prepared. Once your order ships, you’ll receive tracking information so you can follow your delivery."
          )}
        </Typography>
      </WhiteCard>
      <WhiteCard gap={1}>
        <Typography fontWeight={700} color="#3BB273" variant="body2">
          {t(`${component}.card-3.header`, "Injection Instructions")}
        </Typography>
        <Typography>
          {t(
            `${component}.card-3.text`,
            "Injection instructions and guidance will be available in your Care page once your medication is on the way."
          )}
        </Typography>
      </WhiteCard>
      <WhiteCard gap={1}>
        <Typography variant="body2" fontWeight={700} color="#00B6B8">
          {t(`${component}.card-4.header`, "Continued weight loss support")}
        </Typography>
        <Typography>
          {t(
            `${component}.card-4.text`,
            "Your care doesn’t stop after delivery. You can message or call your care team anytime for questions, dose guidance, and ongoing support."
          )}
        </Typography>
        <Typography>
          {t(`${component}.card-4.text-2`, "Text or call:")} 305-395-5016
        </Typography>
      </WhiteCard>
    </Stack>
  );
};

export default GLP1NextSteps;
